export const techStack = [
  {
    name: "React",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
  },
  {
    name: "Next.js",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
  },
  {
    name: "TypeScript",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
  },
  {
    name: "JavaScript",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    name: "React Native",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  },
  {
    name: "Expo",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/expo/expo-original.svg",
  },
  {
    name: "Node.js",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
  },
  {
    name: "Tailwind",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
  },
  {
    name: "GraphQL",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
  },
  {
    name: "Firebase",
    link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
  },
  {
    name: "Redux",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
  },
  {
    name: "MongoDB",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
  },
  {
    name: "MySQL",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
  },
  {
    name: "Git",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
  },
  {
    name: "Three.js",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/threejs/threejs-original.svg",
  },
  {
    name: "Framer Motion",
    link: "https://cdn.worldvectorlogo.com/logos/framer-motion.svg",
  },
];

export const contactLinks = [
  {
    name: "GitHub",
    url: "https://cdn.simpleicons.org/github/111827",
    link: "https://github.com/aakashsh1999",
  },
  {
    name: "LinkedIn",
    url: "https://cdn.simpleicons.org/linkedin/1d6fd8",
    link: "https://www.linkedin.com/in/aakashsh1999/",
  },
  {
    name: "Instagram",
    url: "https://cdn.simpleicons.org/instagram/111827",
    link: "https://www.instagram.com/aakashsh1999/",
  },
  {
    name: "Stack Overflow",
    url: "https://cdn.simpleicons.org/stackoverflow/f48024",
    link: "https://stackoverflow.com/users/11788531/aakash-sharma",
  },
];

export const RESUME_URL = "/Akash_Sharma_Resume.pdf";
